import { AccountViewParams } from '@lk/api/account/models'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accountViewByPage = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] VIEW_BY_PAGE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view(params.page, params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accountViewBase = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] BASE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('base', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accountViewSTMT = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] STMT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('stmt', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountViewCustFields = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] CUST_FIELDS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('custfields', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountViewBalance = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] BALANCE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('balance', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountViewAccessPerms = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] ACCESS_PERMS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('accessperms', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountViewPrintAccstatement = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] PRINT_ACCSTATEMENT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('printaccstatement', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountViewPermsList = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] PERMS_LIST',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('permslist', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const accountViewGetBalance = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] GET_BALANCE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('balance', params)
    if (result.success) {
      return result.data
    }
    return rejectWithValue(result.error.message)
  },
)

export const accountPrint = createAsyncThunk<any, Partial<AccountViewParams>, ThunkApi>(
  '[ACCOUNT_VIEW] GET_BALANCE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.account.view('printaccstatement', params)
    if (result.success) {
      return result.data
    }
    return rejectWithValue(result.error.message)
  },
)
